import axios from "axios";
import mylogin from '@/components/index.js'
import Vue from "vue";

import { Message, MessageBox, Notification } from "element-ui";
// 需要忽略的提示。忽略后，自动 Promise.reject('error')
const ignoreMsgs = [
  "无效的刷新令牌", // 刷新令牌被删除时，不用提示
  "刷新令牌已过期", // 使用刷新令牌，刷新获取新的访问令牌时，结果因为过期失败，此时需要忽略。否则，会导致继续 401，无法跳转到登出界面
];
// 是否显示重新登录
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000,
  // 禁用 Cookie 等信息
  withCredentials: false,
});

// 请求request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["tenant-id"] = process.env.VUE_APP_TENANT_ID;
    config.headers["site-id"] = process.env.VUE_APP_SITE_ID;
    config.headers["appId"] = process.env.VUE_APP_ID;
    let token = localStorage.getItem("token");
    if (token) {
      config.headers["user-token"] = token;
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        const part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              const subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
    if (res.data.code == 600) {
      // token失效，重新登录
      // 获取是那个接口错误
      let url = res.config.url;
      if (url.indexOf("/user/getUserInfo/wechat_mp") != -1) {
      } else {
        handleAuthorized();
      }
    }
    return res.data;
  },
  (error) => {
    console.log('err' + error)
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "操作过于频繁"
    }
    Message({
      message: message,
      type: "error",
    })
    return Promise.reject(error);
  }
);

function handleAuthorized() {
  if (window.location.href.indexOf("sa.tiehouedu.com") > -1) {
    window.location.href = window.origin + "/xzzj/pc/#/login";
  } else if (window.location.href.indexOf("xzzhuanji.cn/migrate") > -1) {
    window.location.href = window.origin + "/migrate/pc/#/login";
  } else {
    window.location.href = window.origin + "/#/login";
  }

}
export default service;
